module.exports = __webpack_public_path__ + "media/src/assets/Images/LinkedIn-4b8c060fe924307c436ea1424589dfd6.svg";